export const url =
  "https://community-open-weather-map.p.rapidapi.com/forecast?q=";

export const headers = {
  "x-rapidapi-key": "c70a007cc8msh36ea9f55a84a7c9p152cfcjsn1e826a06048c",
  "x-rapidapi-host": "community-open-weather-map.p.rapidapi.com",
};
